import styled from 'styled-components';

const Grid = styled.section`
  display: flex;
  flex-wrap: wrap;
`;

export default Grid;
